<template>

  <div class=" detail_block booking-component">
    <h4>
       <i class="fa fa-arrow-right"></i>  {{ bookingBusinessText }}
      <a href="#"  @click="Change_booking_business_type">   <i class="fa fa-pencil"></i></a>
     </h4>
    <ul id="address_list">
      <li >    <i class="fa fa-arrow-right"></i>  <span > {{  this.transbookingBusinessType }}</span> </li>
    </ul>
  </div>
</template>
<script>
//  import {getBookingImages} from "@/modules/CustomerPortal/api/bookings/view";
export default {
  name: "BookingOverViewBusinessTypeLocationType",
  //components: {getBookingImages},
  props: [
    "bookingBusinessType",
    "bookingId",

  ],
  data() {
     return {
       transbookingBusinessType:  trans(this.bookingBusinessType),
       bookingBusinessText:  trans('Business_type'),
       Change_booking_business_type_title:  trans('Change_booking_business_type_title'),
       Change_booking_business_type_Description:  trans('Change_booking_business_type_Description'),
       cancelText:  trans('cancel'),
       confirmText:  trans('continue'),
    }
  },
  methods:{
    Change_booking_business_type : function warningChange(){

      confirm_popup({
        title: this.Change_booking_business_type_title,
        message: this.Change_booking_business_type_Description,
        confirm: this.confirmText,
        cancel: this.cancelText,
      }, function () {
        /** clearBookingServices  ==>> to delete booking data **/

        clearBookingServices(1,0,"and_delete_estimate");
      }, function () {
      },1);

    }
  }
  ,mounted() {}
}


</script>

<style scoped>
</style>
